import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
import {
    Menu, ChevronLeft, Home, LayoutDashboard, BarChart3,
    Wallet, Ticket, Globe, Settings2, CreditCard,ChevronRight,FileCode
} from "lucide-react";
import Footer from "./Footer";

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    const { authState } = useAuth();
    const user = authState.user;

    const menuItems = [
        { path: "/home", label: "Home", icon: <Home size={20} /> },
        { path: "/overview", label: "Overview", icon: <LayoutDashboard size={20} /> },
        { path: "/analytics", label: "Analytics", icon: <BarChart3 size={20} /> },
        { path: "/transactions", label: "Transactions", icon: <Wallet size={20} /> },
        { path: "/qa-tickets", label: "QA Tickets", icon: <Ticket size={20} /> },
        { path: "/website", label: "Website/Apps", icon: <Globe size={20} /> },
        { path: "/settings", label: "Settings", icon: <Settings2 size={20} /> },
        { path: "/payment", label: "Payment", icon: <CreditCard size={20} /> },
        { path: "/invoice", label: "Invoice", icon: <CreditCard size={20} /> },
        { path: "/adscode", label: "Assigned Adscode", icon: <FileCode size={20} /> }
    ];

    return (
        <div className="relative flex">
            {/* Sidebar */}
            <div className={`fixed top-0 left-0 h-full bg-white shadow-lg text-gray-800 transition-all duration-300 z-50 
                ${isOpen ? "w-64 translate-x-0" : "w-16 -translate-x-0"} md:relative md:translate-x-0`}>

                {/* Sidebar Toggle Button (Desktop) */}
                <button
                    className="absolute top-4 right-4 text-gray-500 hidden md:block"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <ChevronLeft size={24} /> : <ChevronRight size={24} />}
                </button>

                {/* Logo */}
                <div className="flex justify-center items-center bg-gray-100 p-4">
                    <img
                        src="./Images/logos/weblogo.png"
                        className={`h-16 object-contain transition-all duration-300 ${isOpen ? "block" : "hidden"}`}
                        alt="Logo"
                    />
                </div>

                {/* Menu Items */}
                <ul className="space-y-2 pt-6">
                    {menuItems.map(({ path, label, icon }) => (
                        <Link key={path} to={path} className="block">
                            <li
                                className={`flex items-center gap-3 p-3 mx-2 cursor-pointer rounded-lg transition-all duration-200
                                    ${isActive(path) ? "bg-purple-700 text-white shadow-md shadow-purple-300"
                                        : "text-gray-700 hover:bg-gray-100 hover:text-purple-700"}
                                    ${isOpen ? "justify-start" : "justify-center"}`}
                            >
                                {icon}
                                <span className={`transition-all duration-300 ${isOpen ? "block" : "hidden"}`}>
                                    {label}
                                </span>
                            </li>
                        </Link>
                    ))}
                </ul>

                <Footer />
            </div>

            {/* Mobile Toggle Button */}
            <button
                className="md:hidden p-3 text-gray-800 fixed top-4 left-4 z-50 bg-white rounded-full shadow-lg"
                onClick={() => setIsOpen(!isOpen)}
            >
                <Menu size={28} />
            </button>
        </div>
    );
};

export default Sidebar;
